import { data } from '../../svg/AIStar/data';
import { makeIcon } from '../makeIcon';

export const AIStar = makeIcon(data, 'ai_star', 'AIStar');

export default AIStar;
